export const DAY = 86400;
export const WEEK = 7 * DAY;
export const MONTH = 30 * DAY;